import React, { Component } from 'react';
import AdminFunctions from '../admin/AdminFunctions';
import AccountFunctions from '../services/AccountService';
import InstrumentFunctions from '../services/InstrumentService'
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';
import '../layout/print.css'
import Modal from 'react-bootstrap/Modal';
import Session from '../auth/Session';
import AuthFunctions from '../services/AuthService';

export class NewPackingList extends Component {
    static displayName = NewPackingList.name;

    constructor(props) {
        super(props);

        this.state = {
            siteList: [],
            client: null,
            search: null,
            instruments: [],
            printItems: [],
            Account: { notes: [] },
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            manufacturer: '',
            toolDescription: '',
            modelNum: '',
            sizeRange: '',
            serialNum: '',
            noOfPieces: '',
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100,
            numberOfPages: 0,
            Upload: false,
            showToast: false,
            showPopup: false,
            showPackingList: false,
            poNo: '',
            useCC: 'No',
            instructions: '',
            fileUpload: null,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClosePopup = this.handleClosePopup.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handleCreatePackingList = this.handleCreatePackingList.bind(this);
        this.handlePackingListCreate = this.handlePackingListCreate.bind(this);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    handleClose() {
        this.setState({ showToast: false, showPackingList: false, showPopup: false });
    }

    handleClosePopup() {
        this.setState({ showPopup: false });
    }

    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.instruments.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.instruments.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.instruments.length / pageSize) })
        }
    }

    handlePackingListCreate() {
        var items = this.state.instruments.slice(0);
        this.setState({ printItems: items });
        this.setState({ poNo: '', useCC: 'No', instructions: '', showPackingList: true});
    }

    handleCreatePackingList() {
        this.setState({showPackingList: false});
        this.handlePackingListSubmission();

        setTimeout(() => {
            window.print();
        }, 500);
    }

    async handleInstrumentListUpload(fileData) {
        const formData = new FormData();

        formData.append('File', fileData);

        var response = await InstrumentFunctions.postInstrumentListUploadAsync(formData);

        if (response != null) {
            this.setState({ showPopup: true });
        }
    }

    async handleQuoteRequestSubmission() {
        var items = this.state.instruments.slice(0);

        var data = { poNo: '', useCC: false, instructions: '', data: items }

        var response = await InstrumentFunctions.postNewQuoteRequestAsync(data);

        if (response != null) {
            this.setState({ showToast: true });
        }
    };

    async handlePackingListSubmission() {
        var items = this.state.instruments.slice(0);

        var data = { poNo: this.state.poNo, useCC: this.state.useCC == 'Yes', instructions: this.state.instructions, data: items }

        var response = await InstrumentFunctions.postNewPackingListAsync(data);
    };

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        //this.setWindowDimensions();
        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {

        }
        else {
        }
        this.getAccountData();
    }

    async getAccountData() {
        var account = await AccountFunctions.getAccountAsync();

        if (account.success == true) {
            if (account.data != null) {
                var data = account.data;
                if (data.customerAddress1 === data.shipToAddress1 && data.customerAddress2 == data.shipToAddress2 && data.customerCity === data.shipToCity && data.customerState === data.shipToState && data.customerZip === data.shipToZip) {
                    this.setState({ shippingSame: true });
                    data.shippingSame = true;
                } else {
                    this.setState({ shippingSame: false });
                    data.shippingSame = false;
                }
                var original = JSON.stringify(data);
                this.setState({ Account: data, OriginalAccount: original });
            }
        }
    }

    //setWindowDimensions = () => {
    //    this.setState({
    //        height: window.innerHeight,
    //        width: window.innerWidth
    //    });
    //};

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.searchInstruments();
        }
    }

    handleDelete(index) {
        var instruments = this.state.instruments;
        if (index > -1 && index < instruments.length) {
            instruments.splice(index, 1);
            this.setState({ instruments: instruments });
        }
    }

    handleAdd() {
        var manufacturer = this.state.manufacturer;
        var description = this.state.toolDescription;
        var model = this.state.modelNum;
        var size = this.state.sizeRange;
        var serialno = this.state.serialNum;
        var pieces = this.state.noOfPieces;

        if (manufacturer === "")
            manufacturer = "N/A";
        if (description === "")
            description = "N/A";
        if (model === "")
            model = "N/A";
        if (size === "")
            size = "N/A";
        if (serialno === "")
            serialno = "N/A";
        if (pieces === "")
            pieces = "N/A"

        if (manufacturer != "" && description != "" && model != "" && size != "" && serialno != "" && pieces != "") {
            var instruments = this.state.instruments;
            instruments.push({ manufacturer: manufacturer, model: model, serialNo: serialno, description: description, range: size, qty: pieces });
            this.setState({ instruments: instruments, manufacturer: '', toolDescription: '', modelNum: '', sizeRange: '', serialNum: '', noOfPieces: '' });
        }
    }

    render() {
        // Logic for displaying instruments!
        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.instruments.slice(indexOfFirstItem, indexOfLastItem);

        const renderItems = currentItems.map((instrument, i) => {
            return (
                <tr key={i}>
                    <td><a href="javascript:void(0)" onClick={() => this.handleDelete(i)}>Delete</a></td>
                    <td>{instrument.manufacturer}</td>
                    <td>{instrument.model}</td>
                    <td>{instrument.serialNo}</td>
                    <td>{instrument.description}</td>
                    <td>{instrument.range}</td>
                    <td>{instrument.qty}</td>
                </tr>
            )
        });

        const renderPrintItems = this.state.printItems.map((instrument, i) => {
            return (
                <tr key={i}>
                    <td>{instrument.manufacturer}</td>
                    <td>{instrument.model}</td>
                    <td>{instrument.serialNo}</td>
                    <td>{instrument.description}</td>
                    <td>{instrument.range}</td>
                    <td>{instrument.qty}</td>
                </tr>
            )
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.instruments.length / this.state.itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number}>{number}</option>
            );
        });

        return (
            <>
                <div className='content-area'>
                    <Container>
                        <Row>
                            <Col>
                                <h2 style={{ color: '#233c7c' }}>New Instruments</h2>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px', paddingLeft: '20px' }}>
                            <Col>
                                <Input
                                    tabIndex='0'
                                    type='radio'
                                    onClick={(e) => this.setState({ Upload: true })}
                                    name='search'
                                    id='search'
                                    checked={this.state.Upload === true}
                                    value='Upload'
                                    onKeyPress={this.handleKeyPress}
                                    placeholder=''
                                />
                                <span> Upload Instrument List</span>
                                <span className="">
                                    <Input
                                        tabIndex='2'
                                        type='file'
                                        onChange={(e) => { this.setState({ Upload: true }); this.handleInstrumentListUpload(e.target.files[0]); }}
                                        name='fileUpload'
                                        id='fileUpload'
                                        style={{ width: '50%', display: 'inline-block', marginLeft: '10px' }}
                                        placeholder='Upload'
                                    />
                                </span>
                            </Col>

                        </Row>
                        <Row style={{ paddingLeft: '20px' }}>
                            <Col>
                                <Input
                                    tabIndex='1'
                                    type='radio'
                                    onClick={(e) => this.setState({ Upload: false })}
                                    name='search'
                                    id='search'
                                    checked={this.state.Upload === false}
                                    value='Entry'
                                    onKeyPress={this.handleKeyPress}
                                    placeholder=''
                                />
                                <span> New Instrument</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    tabIndex='3'
                                    type='text'
                                    name='Manufacturer'
                                    disabled={this.state.Upload}
                                    id='Manufacturer'
                                    className='fullInput'
                                    value={this.state.manufacturer}
                                    onChange={(e) => this.setState({manufacturer: e.target.value})}
                                    placeholder='Manufacturer'
                                />
                            </Col>
                            <Col>
                                <Input
                                    tabIndex='4'
                                    type='text'
                                    name='ToolDescription'
                                    disabled={this.state.Upload}
                                    id='ToolDescription'
                                    className='fullInput'
                                    value={this.state.toolDescription}
                                    onChange={(e) => this.setState({ toolDescription: e.target.value })}
                                    placeholder='Tool Description'
                                />
                            </Col>
                            <Col className='buttonCol'>
                                <Button
                                    tabIndex='9'
                                    color='primary'
                                    className='standardButton'
                                    onClick={() => this.handleAdd()}
                                    disabled={this.state.loading ? true : false}
                                >
                                    Add Instrument
                                </Button>
                            </Col>
                            <Col className='buttonCol' style={{ textAlign: 'right' }}>
                                <Button
                                    tabIndex='10'
                                    color='primary'
                                    className='standardButton'
                                    onClick={(e) => { this.handleQuoteRequestSubmission() }}
                                    disabled={this.state.loading ? true : false}
                                >
                                    Request Quote
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <Input
                                            tabIndex='5'
                                            type='text'
                                            name='ModelNum'
                                            disabled={this.state.Upload}
                                            id='ModelNum'
                                            className='fullInput'
                                            value={this.state.modelNum}
                                            onChange={(e) => this.setState({ modelNum: e.target.value })}
                                            placeholder='Model #'
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            tabIndex='6'
                                            type='text'
                                            name='SizeRange'
                                            disabled={this.state.Upload}
                                            id='SizeRange'
                                            className='fullInput'
                                            value={this.state.sizeRange}
                                            onChange={(e) => this.setState({ sizeRange: e.target.value })}
                                            placeholder='Size / Range'
                                        />
                                    </Col>
                                    <Col></Col>
                                    <Col className='buttonCol'
                                        style={{ textAlign: 'right' }}>
                                        <Button
                                            tabIndex='11'
                                            color='primary'
                                            className='standardButton'
                                            onClick={() => this.handlePackingListCreate()}
                                            disabled={this.state.loading ? true : false}
                                        >
                                            Create Packing List
                                        </Button>
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <Input
                                            tabIndex='7'
                                            type='text'
                                            name='SerialNum'
                                            disabled={this.state.Upload}
                                            id='SerialNum'
                                            className='fullInput'
                                            value={this.state.serialNum}
                                            onChange={(e) => this.setState({ serialNum: e.target.value })}
                                            placeholder='Serial #'
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            tabIndex='8'
                                            type='text'
                                            name='NumPieces'
                                            disabled={this.state.Upload}
                                            id='NumPieces'
                                            className='fullInput'
                                            value={this.state.noOfPieces}
                                            onChange={(e) => this.setState({ noOfPieces: e.target.value })}
                                            placeholder='# of Pieces (if applicable)'
                                        />
                                    </Col>
                                    <Col></Col>
                                    <Col></Col>
                                </Row>

                            </Col>
                        </Row>
                        {this.state.instruments.length !== 0 && (
                            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px' }}>
                                <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                    {renderPageNumbers}
                                </select>
                                <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        )}
                        <Row style={{ marginTop: '20px' }}>
                            <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                Delete
                                            </th>
                                            <th>
                                                Manufacturer
                                                <FaSort
                                                    color={this.state.sort.column === 'manufacturer' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('manufacturer')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Model #
                                                <FaSort
                                                    color={this.state.sort.column === 'model' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('model')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Serial #
                                                <FaSort
                                                    color={this.state.sort.column === 'serialNo' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('serialNo')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Tool Description
                                                <FaSort
                                                    color={this.state.sort.column === 'description' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('description')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Size / Range
                                                <FaSort
                                                    color={this.state.sort.column === 'range' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('range')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                # of Pieces
                                                <FaSort
                                                    color={this.state.sort.column === 'qty' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('qty')}
                                                    className='sort-button'
                                                />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loading === true && this.state.loadingDocument === false ? (
                                            <tr>
                                                <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <Spinner color="primary" children='' />
                                                </td>
                                            </tr>

                                        ) : (
                                            <>
                                                {!this.state.noResults ? (
                                                    <>
                                                        {renderItems}
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                            <h5>No Results Found</h5>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        {this.state.instruments.length !== 0 && (
                            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px', marginBottom: '50px' }}>
                                <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                    {renderPageNumbers}
                                </select>
                                <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>

                            </div>
                        )}
                    </Container>
                    <Modal show={this.state.showToast} onHide={this.handleClose}>
                        <Modal.Header >
                            <Modal.Title>Email Sent!</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Thank you for requesting a quote for calibration.  A <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span> team member is working on your quote.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.showPopup} onHide={this.handleClosePopup} dialogClassName="modelWidth">
                        <Modal.Header >
                            <Modal.Title>Email Sent!</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>Thank you for contacting <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span>, your file has been sent for our review!</div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className='standardButton btn btn-primary' onClick={this.handleClosePopup}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.showPackingList} onHide={this.handleClose}>
                        <Modal.Header >
                            <Modal.Title>Create Packing List</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Col>
                                <Row>
                                    <Input
                                        type='text'
                                        onChange={(e) => this.setState({ poNo: e.target.value })}
                                        name='PONo'
                                        id='poNo'
                                        className='fullInput'
                                        value={this.state.poNo}
                                        placeholder='PO #'
                                    />
                                </Row>
                                <Row className='row-10'>
                                    <label>
                                        <Input
                                            type='checkbox'
                                            onChange={(e) => this.setState({ useCC: e.target.checked ? 'Yes' : 'No' })}
                                            name='useCC'
                                            id='useCC'
                                            className='fullInput'
                                            value={this.state.useCC == 'Yes'}
                                            placeholder='Use CC'
                                        />
                                        Pay with credit card?
                                    </label>
                                </Row>
                                <Row className='row-10'>
                                    <textarea
                                        onChange={(e) => this.setState({ instructions: e.target.value })}
                                        name='instructions'
                                        id='instructions'
                                        maxLength={500}
                                        className='form-control marginTop fullInput'
                                        value={this.state.instructions}
                                        placeholder='Special Instructions'
                                    />
                                </Row>
                            </Col>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" className="standardButton btn btn-primary" onClick={this.handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" className="standardButton btn btn-primary" onClick={this.handleCreatePackingList}>
                                Print Packing List
                            </Button>
                        </Modal.Footer>
                    </Modal>                         
                </div>
                <div className='print-area'>
                    <Container>
                        <Row>
                            <Col>
                                <Table responsive className='borderless-table'> 
                                    <tbody>
                                        <tr>
                                            <td colSpan={'2'} style={{ textAlign: 'center' }}>
                                                <img src="/images/ticlogo.jpg" style={{ height: '80px', margin: '12px' }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={'2'} style={{ textAlign: 'center' }}>
                                                <h3>Packing List</h3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><b>PO #:</b>&nbsp;{this.state.poNo}</td>
                                            <td><b>Credit Card:</b>&nbsp;{this.state.useCC}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={'2'} style={{ whiteSpace: 'unset' }}><b>Special Instructions:</b>&nbsp;{this.state.instructions}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table responsive className='borderless-table'> 
                                    <thead>
                                        <th>
                                            <h3>Company Information</h3>
                                        </th>
                                        <th>
                                            <h3>Quality Contact</h3>
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Table responsive>
                                                    <tbody>
                                                        <tr>
                                                            <td><b>TIC #:</b></td>
                                                            <td>{this.state.Account.ticNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Company Name:</b></td>
                                                            <td>{this.state.Account.customerName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Address:</b></td>
                                                            <td>{this.state.Account.customerAddress1}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Address 2:</b></td>
                                                            <td>{this.state.Account.customerAddress2}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>City, State, Zip:</b></td>
                                                            <td>{this.state.Account.customerCity}, {this.state.Account.customerState} {this.state.Account.customerZip}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </td>
                                            <td>
                                                <Table responsive>
                                                    <tbody>
                                                        <tr>
                                                            <td><b>Name:</b></td>
                                                            <td>{this.state.Account.qcName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Office Phone:</b></td>
                                                            <td>{this.state.Account.qcPhone} ext. {this.state.Account.qcExt}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Email:</b></td>
                                                            <td>{this.state.Account.qcEmail}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Container>
                    <Container>
                        <Row className='row-20'>
                            <Col>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                Mfg.
                                            </th>
                                            <th>
                                                Model #
                                            </th>
                                            <th>
                                                Serial #
                                            </th>
                                            <th>
                                                Description
                                            </th>
                                            <th>
                                                Size / Range
                                            </th>
                                            <th>
                                                # of Pieces
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <>
                                            {renderPrintItems}
                                        </>
                                    </tbody>
                                </Table>                            
                            </Col>
                        </Row>
                    </Container>
                </div>
           </>
        )
    }

    // instruments

    async searchInstruments() {
        this.setState({ loading: true, loadingDocument: false });
        const token = Session.getToken();
        const query = this.state.search ? this.state.search : '';
        //const clientId = (this.state.client && this.state.client.length !== 0) ? this.state.client[0].id : 0;
        var client = (this.state.client && this.state.client.length !== 0) ? this.state.client[0] : '';

        if (typeof client !== 'string' && !(client instanceof String)) {
            client = client.label;
        }

        const response = await fetch(`api/Account/SearchInstruments?query=${query}&client=${client}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ instruments: data, loading: false, noResults: data.length === 0 ? true : false });
    }

    // table sort

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.instruments;
        data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            instruments: data,
            sort: {
                column,
                direction
            }
        })
    }
}